import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../axios";
import { getPaginatedData } from "../../../../_helpers";
import { Loading } from "../../../Other/Loading";
import Pagination from "./Pagination";
const { REACT_APP_PAYMENT_API_BASEURL } = process.env;

const staticData = [
  {
    name: "Total Instructors",
    total: 486,
    boxShadow: "Dashboard-color-one",
    color: "color-one",
  },
  {
    name: "Pending Request",
    total: 35,
    boxShadow: "Dashboard-color-two",
    color: "color-two",
  },
  {
    name: "Without Course",
    total: 24,
    boxShadow: "Dashboard-color-three",
    color: "color-three",
  },
  {
    name: "Self Created",
    total: "08",
    boxShadow: "Dashboard-color-four",
    color: "color-four",
  },
];

const StudentData = () => {
  const [studentsData, setStudentsData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);

  const { data, startIndex, totalPageCount } = getPaginatedData(
    studentsData,
    currentPage
  );

  useEffect(() => {
    const fetch = () => {
      axiosInstance
        .get(`${REACT_APP_PAYMENT_API_BASEURL}/v2/student-report`)
        .then((res) => {
          setStudentsData(res?.data?.data);
        })
        .catch((error) => {
          console.log(error);
        });
    };
    fetch();
  }, []);

  return (
    <div className="width-0">
      <div className="dashboard-container-new">
        <p>Summary Report For Students</p>
        <div>
          <button className="lastmonth-btn">Last Month</button>
          <button className="export-btn">Export</button>
        </div>
      </div>

      <div className="flex-dashboard-new-1">
        {staticData?.map((item, index) => (
          <div className={`box-shadow-06 ${item.boxShadow}`} key={index}>
            <p className="font-custom-p">{item.name}</p>
            <p className={`font-increase ${item.color}`}>{item.total}</p>
          </div>
        ))}
      </div>

      <div className="page-data-new">
        {data?.length > 0 ? (
          <p className="showing-result">
            Showing page {currentPage} of {totalPageCount} results
          </p>
        ) : (
          <p className="showing-result">Showing 0 result</p>
        )}
      </div>

      <div className="instructor-table">
        {
          // data?.length === 0 ? (
          //   <Loading />
          // ) :
          <table className="table-width-100">
            <thead>
              <tr>
                <th>S.no</th>
                <th>Student Id</th>
                <th>Student Name</th>
                <th>Courses</th>
                <th>Amount Paid</th>
                <th>Total Completed</th>
                <th>Total Hours</th>
              </tr>
            </thead>
            {/* <tbody>
              {data?.map((ele, index) => {
                return (
                  <tr key={index}>
                    <td className="cell">
                      {currentPage * 10 - 10 + index + 1}
                    </td>
                    <td className="cell">{ele.StudentId}</td>
                    <td className="cell">{ele.StudentName}</td>
                    <td className="cell">{ele.Courses}</td>
                    <td className="cell">$ {ele.AmountPaid}</td>
                    <td className="cell">{ele.Completed}</td>
                    <td className="cell">
                      {ele.TotalHours === null ? 0 : ele.TotalHours}
                    </td>
                  </tr>
                );
              })}
            </tbody> */}
          </table>
        }
      </div>
      <div className="pageNumbers-sudents">
        {/* <Pagination
          className="pageNumbers-sudents"
          currentPage={currentPage}
          totalCount={10}
          pageSize={totalPageCount}
          onPageChange={(page) => setCurrentPage(page)}
        /> */}
      </div>
    </div>
  );
};

export default StudentData;
